import React, { useEffect, useState } from 'react';
import { ColorPicker } from 'primereact/colorpicker';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { fetchCroppedImage } from '@/utils/constants';
import { postData } from '@/services/api.service';
import { toast } from 'react-toastify';
import { ImageType } from '@/services/openai.service';
import AIContentWriter from '@/components/AIContentWriter';
import AIImageGenerator from '@/components/AIImageGenerator';
import {
  area_bg,
  area_covered,
  hero_img_wonderwash,
  heroimg,
  heroimg_2,
  home_page_single_search,
  home_page_single_search2,
} from '@/utils/imagepath';
import { useSelector, useDispatch } from 'react-redux';
import { setTemplateImages } from '@/core/redux/commonSlice';
import { RootState } from '@/core/redux/store';

const BannerEditModal = ({ themeData, getThemeData }: any) => {
  const [editedData, setEditedData] = useState<any>(themeData);
  const [showCropModal, setShowCropModal] = useState<boolean>(false);
  const [imagedata, setImagedata] = useState<any>(null);
  const [showCropModalTwo, setShowCropModalTwo] = useState<boolean>(false);

  const dispatch = useDispatch();
  const headerData = useSelector((state: RootState) => state.common.header);
  const templateImages = useSelector((state: RootState) => state.common.templateImages);
  const [template, setTemplate] = useState(headerData?.template);

  const [backgroundImages, setBackgroundImages] = useState<string[]>([]);
  const [bannerImages, setBannerImages] = useState<string[]>([]);

  const images: Array<string> = [
    home_page_single_search,
    area_covered,
    area_bg,
    home_page_single_search2,
  ];
  const banner: Array<string> = [
    heroimg,
    heroimg_2,
    hero_img_wonderwash,
  ];
  const setBannerType = (type: string) => {
    setEditedData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_3: {
        ...prevJsonData.theme_3,
        home: {
          ...prevJsonData.theme_3.home,
          section_1: {
            ...prevJsonData.theme_3.home.section_1,
            banner_type: type,
          },
        },
      },
    }));
  };
  const handleChange = (e: any) => {
    const { value, name, type, checked } = e.target;

    setEditedData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_3: {
        ...prevJsonData?.theme_3,
        home: {
          ...prevJsonData?.theme_3.home,
          section_1: {
            ...prevJsonData?.theme_3?.home.section_1,
            [name]: value,
            btn_group: {
              ...prevJsonData?.theme_3?.home.section_1.btn_group,
              btn1: {
                ...prevJsonData?.theme_3?.home.section_1.btn_group.btn1,
                [name]: value,
              },
            },
            mobile_link_section: {
              ...prevJsonData?.theme_3?.home.section_1.mobile_link_section,
              [name]: value,
              is_enable:
                type === 'checkbox' && name === 'is_enable'
                  ? !prevJsonData?.theme_3?.home.section_1.mobile_link_section
                    .is_enable
                  : prevJsonData?.theme_3?.home.section_1.mobile_link_section
                    .is_enable,
            },
          },
        },
      },
    }));
  };
  const handleImageChange = (image: string) => {
    //Update the banner value in the JSON data
    setEditedData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_3: {
        ...prevJsonData.theme_3,
        home: {
          ...prevJsonData.theme_3.home,
          section_1: {
            ...prevJsonData.theme_3.home.section_1,
            banner: image,
          },
        },
      },
    }));
  };
  const handleCroppedImage = async (image: any) => {
    setShowCropModal(false);
    setImagedata(image);
    const imageLink = await fetchCroppedImage(image);
    if (imageLink != false) {
      handleImageChange(imageLink);
    }
  };
  const updateImageSectionOne = async (e: any) => {
    const image = e.target.files[0];
    // setCropImageHeight("150");
    // setCropImageWidth("300");
    // setSelectedCropImage(image);
    // setShowCropModal(true);
    if (image instanceof File) {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (res: any) => {
        handleCroppedImage(res.target.result);
      };
    }
  };
  const handleImageChangeTwo = (image: string) => {
    //Update the banner value in the JSON data
    setEditedData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_3: {
        ...prevJsonData.theme_3,
        home: {
          ...prevJsonData.theme_3.home,
          section_1: {
            ...prevJsonData.theme_3.home.section_1,
            banner_two: image,
          },
        },
      },
    }));
  };
  const handleCroppedImageTwo = async (image: any) => {
    setShowCropModalTwo(false);
    setImagedata(image);
    const imageLink = await fetchCroppedImage(image);
    if (imageLink != false) {
      handleImageChangeTwo(imageLink);
    }
  };
  const updateImageSectionTwo = async (e: any) => {
    const image = e.target.files[0];
    // setCropImageHeight("300");
    // setCropImageWidth("500");
    if (image.type.startsWith('image/')) {
      // setSelectedCropImage(image);
      // setShowCropModalTwo(true);
      setBannerType('image');
      if (image instanceof File) {
        const reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = (res: any) => {
          handleCroppedImageTwo(res.target.result);
        };
      }
    } else if (image.type.startsWith('video/')) {
      // handleCroppedImageTwo(image);
      setBannerType('video');
      if (image instanceof File) {
        const reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = (res: any) => {
          handleCroppedImageTwo(res.target.result);
        };
      }
    }
  };
  const saveJsonData = async () => {
    const payload = {
      cms_json: JSON.stringify(editedData),
    };
    try {
      const response = await postData('save_cms_json', payload);
      if (response.status == 200 || response.status == 201) {
        getThemeData();
        toast.success('Theme Updated Successfully');
      }
    } catch (err) {
      console.error(err);
    } finally {
    }
  };

  // Auto-generate prompt based on banner section context for Background Banner
  const generateAutoPromptBanner = (): string => {
    const title = editedData?.theme_3?.home?.section_1?.title || '';
    const subHeading = editedData?.theme_3?.home?.section_1?.sub_heading_top || '';
    const paragraph = editedData?.theme_3?.home?.section_1?.paragraph || '';
    
    // Build context-based prompt
    let contextPrompt = 'modern professional banner image for website hero section';
    
    if (title || subHeading || paragraph) {
      const contextParts: string[] = [];
      if (paragraph) {
        const keywords = paragraph.split(' ').slice(0, 5).join(' ');
      }
      contextPrompt += `, ${contextParts.join(', ')}`;
    }
    
    // Add banner-specific styling
    contextPrompt += ', clean modern aesthetic, professional photography, suitable for hero banner section, wide landscape format, vibrant colors, high quality, no text, no words, no letters, no typography';
    
    return contextPrompt;
  };

  // Handle AI background banner image save
  const handleAIImageSave = (imageUrl: string) => {
    // Set the banner image
    handleImageChange(imageUrl);
    
    // Add to background images array for slider
    setBackgroundImages(prevImages => [...prevImages, imageUrl]);
  };

  // Auto-generate prompt based on banner section context for Banner Two
  const generateAutoPromptBannerTwo = (): string => {
    const title = editedData?.theme_3?.home?.section_1?.title || '';
    const subHeading = editedData?.theme_3?.home?.section_1?.sub_heading_top || '';
    const paragraph = editedData?.theme_3?.home?.section_1?.paragraph || '';
    
    // Build context-based prompt
    let contextPrompt = 'modern professional image for website banner section';
    
    if (title || subHeading || paragraph) {
      const contextParts: string[] = [];
      if (paragraph) {
        const keywords = paragraph.split(' ').slice(0, 5).join(' ');
      }
      contextPrompt += `, ${contextParts.join(', ')}`;
    }
    
    // Add banner two-specific styling
    contextPrompt += ', clean modern aesthetic, professional photography, suitable for banner section, square format, vibrant colors, high quality, no text, no words, no letters, no typography';
    
    return contextPrompt;
  };

  // Handle AI banner two image save
  const handleAIImageSaveTwo = (imageUrl: string) => {
    // Set the banner two image
    handleImageChangeTwo(imageUrl);
    setBannerType('image');
    
    // Add to banner images array for slider
    setBannerImages(prevImages => [...prevImages, imageUrl]);
  };
  useEffect(() => {
    setEditedData(themeData);
  }, [themeData]);

  useEffect(() => {
    if (editedData != undefined) {
      setEditedData(editedData);
    }
  }, [editedData]);

  // Load existing template images from Redux store with filtering
  useEffect(() => {
    if (templateImages && typeof templateImages === 'object') {
      const templateKey = template ? `template${template}` : 'template3';
      const currentTemplate = templateImages[templateKey];
      const bannerImgs = currentTemplate?.banner || [];
      const imageImgs = currentTemplate?.image || [];
      
      // Helper function to load image dimensions
      const loadImageDimensions = async (url: string): Promise<{ url: string; width: number; height: number } | null> => {
        return new Promise((resolve) => {
          const img = new Image();
          img.onload = () => {
            resolve({ url, width: img.width, height: img.height });
          };
          img.onerror = () => {
            resolve(null);
          };
          img.src = url;
        });
      };

      // Load and filter background banner images (wide/landscape)
      if (Array.isArray(bannerImgs) && bannerImgs.length > 0) {
        const filterBannerImages = async () => {
          const imagePromises = bannerImgs.map((img: any) => loadImageDimensions(img.url));
          const loadedImages = await Promise.all(imagePromises);
          
          // Filter for wide/landscape images (aspect ratio > 1.3) for background
          const wideImages = loadedImages
            .filter((img) => {
              if (img === null) return false;
              const aspectRatio = img.width / img.height;
              return aspectRatio > 1.3;
            })
            .map((img) => img!.url);
          
          setBackgroundImages(wideImages);
        };

        filterBannerImages();
      } else {
        setBackgroundImages([]);
      }

      // Load and filter banner two images (square from image array)
      if (Array.isArray(imageImgs) && imageImgs.length > 0) {
        const filterSquareImages = async () => {
          const imagePromises = imageImgs.map((img: any) => loadImageDimensions(img.url));
          const loadedImages = await Promise.all(imagePromises);
          
          // Filter for square images (aspect ratio 0.9-1.1)
          const squareImages = loadedImages
            .filter((img) => {
              if (img === null) return false;
              const aspectRatio = img.width / img.height;
              return aspectRatio >= 0.9 && aspectRatio <= 1.1;
            })
            .map((img) => img!.url);
          
          setBannerImages(squareImages);
        };

        filterSquareImages();
      } else {
        setBannerImages([]);
      }
    } else {
      setBackgroundImages([]);
      setBannerImages([]);
    }
  }, [templateImages, template]);

  return (
    <>
      {' '}
      <div className="modal-dialog modal-lg modal-dialog-centered theme-edit-modal">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Home Section Banner Theme Edit</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-content modal-body">
            <div className="mb-3">
              <label className="form-label">
                Sub Title <small>(max 250 char)</small>
              </label>
              <input
                type="text"
                className="form-control"
                name="sub_heading_top"
                value={editedData?.theme_3?.home?.section_1?.sub_heading_top}
                onChange={handleChange}
                maxLength={250}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">
                Title<small>(max 250 char)</small>
              </label>
              <input
                type="text"
                className="form-control"
                name="title"
                value={editedData?.theme_3?.home?.section_1?.title}
                onChange={handleChange}
                maxLength={250}
              />
              <div className="mt-2">
                <label className="form-label small">Title Color</label>
                <div className="input-group color-change">
                  <input
                    type="text"
                    className="form-control"
                    name="title_color"
                    value={
                      editedData?.theme_3?.home?.section_1?.title_color || '000000'
                    }
                    onChange={handleChange}
                  />
                  <ColorPicker
                    name="title_color"
                    format="hex"
                    onChange={handleChange}
                    value={
                      editedData?.theme_3?.home?.section_1?.title_color || '000000'
                    }
                  />
                </div>
              </div>
            </div>
            <div className="mb-3">
              <div className="d-flex align-items-center mb-2 flex-wrap gap-2">
                <label className="form-label mb-0 mr-2">
                  Description
                </label>
                <AIContentWriter
                  onContentGenerated={(content) => {
                    handleChange({
                      target: {
                        name: 'paragraph',
                        value: content,
                      },
                    });
                  }}
                  contentType="website_description"
                  placeholder="Describe what you want in your banner description. Example: 'Write about our fast delivery service, 24/7 support, and wide product selection'"
                  context="This is for a website hero banner section description"
                />
              </div>
              <textarea
                className="form-control"
                name="paragraph"
                value={editedData?.theme_3?.home?.section_1?.paragraph}
                onChange={handleChange}
                maxLength={1200}
                rows={3}
              />
              <div className="mt-2">
                <label className="form-label small">Description Color</label>
                <div className="input-group color-change">
                  <input
                    type="text"
                    className="form-control"
                    name="paragraph_color"
                    value={
                      editedData?.theme_3?.home?.section_1?.paragraph_color || '000000'
                    }
                    onChange={handleChange}
                  />
                  <ColorPicker
                    name="paragraph_color"
                    format="hex"
                    onChange={handleChange}
                    value={
                      editedData?.theme_3?.home?.section_1?.paragraph_color || '000000'
                    }
                  />
                </div>
              </div>
            </div>

            <div className="mb-3">
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Button</label>
                    <input
                      type="text"
                      className="form-control"
                      name="text"
                      value={
                        editedData?.theme_3?.home?.section_1?.btn_group?.btn1
                          ?.text
                      }
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Background</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="bg_color"
                        value={
                          editedData?.theme_3?.home?.section_1?.btn_group?.btn1
                            ?.bg_color
                        }
                        onChange={handleChange}
                      />
                      <ColorPicker
                        name="bg_color"
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        format="hex"
                        value={
                          editedData?.theme_3?.home?.section_1?.btn_group?.btn1
                            ?.bg_color
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="color"
                        value={
                          editedData?.theme_3?.home?.section_1?.btn_group?.btn1
                            ?.color
                        }
                        onChange={handleChange}
                      />
                      <ColorPicker
                        name="color"
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        format="hex"
                        value={
                          editedData?.theme_3?.home?.section_1?.btn_group?.btn1
                            ?.color
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="row">
                <div className="col">
                  <div className=" mb-3">
                    <label className="form-label">Button 2</label>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        name="btn2.text"
                        value={
                          editedData?.theme_3?.home?.section_1?.btn_group?.btn2
                            ?.text
                        }
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Background</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="btn2.bg_color"
                        value={
                          editedData?.theme_3?.home?.section_1?.btn_group?.btn2
                            ?.bg_color
                        }
                        onChange={handleChange}
                      />
                      <ColorPicker
                        name="btn2.bg_color"
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        format="hex"
                        value={
                          editedData?.theme_3?.home?.section_1?.btn_group?.btn2
                            ?.bg_color
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="btn2.color"
                        value={
                          editedData?.theme_3?.home?.section_1?.btn_group?.btn2
                            ?.color
                        }
                        onChange={handleChange}
                      />
                      <ColorPicker
                        name="btn2.color"
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        format="hex"
                        value={
                          editedData?.theme_3?.home?.section_1?.btn_group?.btn2
                            ?.color
                        }
                      />
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
            <div className="mb-3">
              <label className="form-label">
                Placeholder <small>(max 50 char)</small>
              </label>
              <input
                type="text"
                className="form-control"
                name="placeholder"
                value={
                  editedData?.theme_3?.home?.section_1?.btn_group?.btn1
                    ?.placeholder
                }
                onChange={handleChange}
                maxLength={50}
              />
            </div>
            <div className="mb-1">
              <div className="row">
                <div className="col-md-12">
                  <label className="form-label">Background Banner</label>
                  <div className="img-bg active">
                    <img
                      src={editedData?.theme_3?.home?.section_1?.banner}
                      alt="Hero Image"
                    />
                  </div>
                  <div className="img-options">
                    <div className="row">
                      <div className="col-md-12">
                        {backgroundImages.length > 0 ? (
                          <Swiper
                            spaceBetween={15}
                            navigation={true}
                            modules={[Navigation]}
                            breakpoints={{
                              640: {
                                slidesPerView: 1,
                              },
                              768: {
                                slidesPerView: 4,
                              },
                              1024: {
                                slidesPerView: 6,
                              },
                            }}
                            className="homejson-slider"
                          >
                            {backgroundImages.map((imageUrl: string, idx: number) => {
                              return (
                                <SwiperSlide key={idx}>
                                  <div
                                    className="img-option"
                                    onClick={() => {
                                      handleImageChange(imageUrl);
                                    }}
                                  >
                                    <img
                                      src={imageUrl}
                                      alt="Hero Image"
                                      className="img-fluid"
                                    />
                                  </div>
                                </SwiperSlide>
                              );
                            })}
                          </Swiper>
                        ) : (
                          <div className="empty-slider-state text-center py-4">
                            <div className="empty-state-content">
                              <i className="fas fa-images fa-3x text-muted mb-3"></i>
                              <h6 className="text-muted mb-2">No Background Images Available</h6>
                              <p className="text-muted small mb-3">
                                Generate AI images or upload your own to see them here
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* AI Image Generator */}
            <AIImageGenerator
              generateAutoPrompt={generateAutoPromptBanner}
              onSave={handleAIImageSave}
              imageType="banner"
              defaultWidth="1792"
              defaultHeight="1024"
              title="AI Image"
              autoGenerate={true}
              template={template}
            />
            <div className="mb-3">
              <label className="form-label">Upload Image</label>
              <input
                type="file"
                accept="image/png, image/jpeg"
                className="form-control"
                name="image"
                onChange={updateImageSectionOne}
              />
            </div>
            <div className="mb-3">
              <div className="row">
                <div className="col-md-12">
                  <label className="form-label">Banner</label>
                  <div className="img-bg active">
                    {editedData?.theme_3?.home?.section_1?.banner_type ==
                      'image' ? (
                      <img
                        src={editedData?.theme_3?.home?.section_1?.banner_two}
                        alt="Hero Image"
                        className="img-fluid"
                      />
                    ) : (
                      <>
                        <video
                          loop
                          autoPlay
                          className="img-fluid"
                          src={editedData?.theme_3?.home?.section_1?.banner_two}
                        ></video>
                      </>
                    )}
                  </div>
                  <div className="img-options">
                    <div className="row">
                      <div className="col-md-12">
                        {bannerImages.length > 0 ? (
                          <Swiper
                            spaceBetween={15}
                            navigation={true}
                            modules={[Navigation]}
                            breakpoints={{
                              640: {
                                slidesPerView: 1,
                              },
                              768: {
                                slidesPerView: 4,
                              },
                              1024: {
                                slidesPerView: 6,
                              },
                            }}
                            className="homejson-slider"
                          >
                            {bannerImages.map((imageUrl: string, idx: number) => {
                              return (
                                <SwiperSlide key={idx}>
                                  <div
                                    className="img-option"
                                    onClick={() => {
                                      handleImageChangeTwo(imageUrl);
                                      setBannerType('image');
                                    }}
                                  >
                                    <img
                                      src={imageUrl}
                                      alt="Hero Image"
                                      className="img-fluid"
                                    />
                                  </div>
                                </SwiperSlide>
                              );
                            })}
                          </Swiper>
                        ) : (
                          <div className="empty-slider-state text-center py-4">
                            <div className="empty-state-content">
                              <i className="fas fa-images fa-3x text-muted mb-3"></i>
                              <h6 className="text-muted mb-2">No Square Images Available</h6>
                              <p className="text-muted small mb-3">
                                Generate AI images or upload your own to see them here
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* AI Image Generator for Banner Two */}
            <AIImageGenerator
              generateAutoPrompt={generateAutoPromptBannerTwo}
              onSave={handleAIImageSaveTwo}
              imageType="image"
              defaultWidth="1024"
              defaultHeight="1024"
              title="AI Image"
              autoGenerate={true}
              template={template}
            />

            <div className="mb-3">
              <label className="form-label">Upload Image</label>
              <input
                type="file"
                accept="image/*"
                className="form-control"
                name="banner_two"
                onChange={updateImageSectionTwo}
              />
            </div>
            <div className="mb-3">
              <button
                type="submit"
                data-bs-dismiss="modal"
                className="btn primary-btn"
                onClick={() => {
                  saveJsonData();
                }}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* {showCropModal ? (
        <>
          <div
            className="modal modal-sm-crop fade show onboarding-modal settings cropModal"
            id="crop-modal"
            tabIndex={-1}
            aria-labelledby="crop-modal"
            aria-hidden="true"
            style={{ display: 'block' }}
          >
            <ImageCropper
              src={selectedCropImage}
              height={cropImageHeight}
              width={cropImageWidth}
              handleCrop={handleCroppedImage}
              close={() => {
                setShowCropModal(false);
              }}
            />
          </div>
        </>
      ) : null}
      {showCropModalTwo ? (
        <>
          <div
            className="modal modal-sm-crop fade show onboarding-modal settings cropModal"
            id="crop-modal"
            tabIndex={-1}
            aria-labelledby="crop-modal"
            aria-hidden="true"
            style={{ display: 'block' }}
          >
            <ImageCropper
              src={selectedCropImage}
              height={cropImageHeight}
              width={cropImageWidth}
              handleCrop={handleCroppedImageTwo}
              close={() => {
                setShowCropModalTwo(false);
              }}
            />
          </div>
        </>
      ) : null} */}
    </>
  );
};

export default BannerEditModal;
